<template>
    <div>
        <p class="text-subtitle1">Assign to Users (Optional)</p>
        <q-separator class="q-mb-sm" />
        <q-input
                v-model="keyword"
                placeholder="Search by name or email"
                autocomplete="no"
                clearable
                clear-icon="fa fa-times"
                dense filled
                class="q-mb-md"
        >
            <template v-slot:prepend>
                <q-icon name="fa fa-search" size="xs" color="primary" />
            </template>
        </q-input>
        <users-list
                :account-id="accountId"
                :keyword="keyword"
                exclude-self
                :selected="modelValue"
                @selection="$emit('update:modelValue', $event)"
        />
        <p v-show="modelValue.length" class="q-mt-md">
            <strong>Assigning to:</strong> {{ assigningTo }}
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User } from '@/type';
import UsersList from '@/user/UsersList.vue';

interface Data {
  keyword: string|null,
}

export default defineComponent({
  emits: ['update:modelValue'],
  components: { UsersList },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Array as () => User[],
      default() {
        return [];
      },
    },
  },
  data(): Data {
    return {
      keyword: null,
    };
  },
  computed: {
    assigningTo(): string {
      return this.modelValue.map(u => `${u.firstName} ${u.lastName}`).join(', ');
    },
  },
});
</script>
